import React, { type ComponentProps } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { BodyText, Icon, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const BundleSlot = (props: Props) => {
  const { label, onPress } = props;

  return (
    <TouchableOpacity
      accessibilityRole="button"
      activeOpacity={0.8}
      style={styles.container}
      onPress={onPress}
    >
      <View style={styles.iconContainer}>
        <Icon name="IconPlus" color={theme.colors.DARK_KALE} />
      </View>

      <BodyText sizeMatch={SLOT_LABEL_SIZE_MATCH} style={styles.label}>
        {label}
      </BodyText>
    </TouchableOpacity>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SLOT_LABEL_SIZE_MATCH: ComponentProps<typeof BodyText>['sizeMatch'] = ['18'];

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing['4'],
    padding: theme.spacing['2'],
    borderRadius: theme.radius.xlarge,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
  iconContainer: {
    padding: theme.spacing['2'],
    borderRadius: theme.radius.xxlarge,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.ALMOST_TRANSPARENT,
  },
  label: {
    flex: 1,
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  label: string;
  onPress?: () => void;
};
